<template>
  <div class="missed-calls">
    <div class="header" @click="toggleExpanded">
      <div class="h2" style="font-size: 13px;">
        Необработанные ({{ uniqueCallsCount }})

        <img  v-if="shouldShowExpandArrow" 
          src="https://1akb.by/images/arsvg.png" 
          :style="{ width: '10px', transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.5s' }" 
          alt="svg">
      
      </div>
    </div>
    <div v-if="calls.length > 0" class="copy-all-container">
      <button @click.stop="copyAllCalls" class="copy-all-btn">
        Скопировать все
        <div v-if="copiedId === 'all'" class="tooltips">
          <i class="fa fa-check"></i> Скопировано!
          <div class="tooltips-arrow"></div>
        </div>
      </button>
    </div>
    <ul v-if="calls.length > 0">
      <li v-for="group in visibleGroupedCalls" :key="group.phone" class="call-group">
        <div class="call-group-header" @click="group.calls.length > 1 ? toggleGroup(group.phone) : (!group.phone || group.phone.trim() === '' ? deleteEmptyCalls() : makeCall(group.phone, group.trunk))">
          <div class="delite_phone" @click.stop="deleteCall(group.phone)"></div>
          <button @click.stop="copyOrderNumber(group.phone)" class="copy-btn" >
            <i class="fa fa-copy">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 2048 2048">
                <path d="M416 0h979v1l31 4 22 6 21 9 16 9 16 12 10 9 13 13 12 16 11 19 9 21 5 18 3 17 1 12v133h129l22 2 15 3 17 5 18 8 18 10 17 13 13 12 10 11 10 14 9 15 7 15 6 17 5 22 2 21v1406l-2 19-4 20-6 18-7 16-13 21-13 16-16 16-19 14-20 11-20 8-15 4-17 3-12 1H711l-21-2-20-5-19-7-16-8-16-10-13-11-11-10-7-8-9-11-12-19-9-19-6-18-4-20-2-20v-129H420l-23-2-20-4-20-7-19-9-11-7-16-12-15-14-7-8-10-13-9-15-8-16-6-16-5-21-2-15-1-26V177l1-18 3-19 6-21 6-15 10-19 12-17 11-12 14-14 15-11 15-9 14-7 24-8 15-3 22-3zm10 94-16 1-13 3-16 8-9 6-8 7-10 13-7 14-4 13-1 6-1 1399 1 16 4 16 8 16 8 11 8 8 13 9 10 5 14 4 8 1 117 1h717l151-1 11-2 12-4 15-8 11-9 8-9 8-13 5-13 2-9 1-10V169l-3-16-5-13-7-12-11-12-8-7-14-8-15-5-5-1-21-1zm1139 298-1 1187-2 19-5 21-7 19-11 21-8 12-11 13-7 8-11 10-17 12-14 8-15 7-18 6-18 4-15 2-44 1H640l-1 1v132l2 11 4 12 7 13 7 9 10 10 12 8 11 5 17 4 13 1h936l42-1 16-4 16-8 10-7 11-11 7-11 6-13 3-11 1-7V465l-3-16-7-16-7-11-13-13-11-7-10-5-13-4-6-1z"></path>
              </svg>
            </i>
            <div v-if="copiedId === group.phone" class="tooltips">
              <i class="fa fa-check"></i> Скопировано!
              <div class="tooltips-arrow"></div>
            </div>
          </button>
          <div class="phone-info">
            <div class="number_phone">
              {{ group.phone }}
            </div>
            <div v-if="group.calls.length > 1" class="call-count">({{ group.calls.length }} пропущенных)</div>
          </div>
          <div v-if="group.calls.length > 1" class="expand-icon" :class="{ expanded: expandedGroups.has(group.phone) }" @click.stop="toggleGroup(group.phone)">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 9l6 6 6-6"/>
            </svg>
          </div>
        </div>
        <ul v-if="group.calls.length > 1 && expandedGroups.has(group.phone)" class="call-times-list">
          <li v-for="call in group.calls" :key="call.id" class="call-time-item">
            <div class="data_phone">{{ formatDate(call.timestamp) }}</div>
            <div v-if="call && call.manager_id" class="call_info">
              <div v-if="call.order_number">Номер заказа: {{ call.order_number }}</div>
              <div v-if="namemanager(call.manager_id)">
                Менеджер: {{ namemanager(call.manager_id) }}
              </div>
            </div>
          </li>
        </ul>
        <div v-if="group.calls.length === 1" class="single-call-info">
          <div class="data_phone">{{ formatDate(group.calls[0].timestamp) }}</div>
          <div v-if="group.calls[0] && group.calls[0].manager_id" class="call_info">
            <div v-if="group.calls[0].order_number">Номер заказа: {{ group.calls[0].order_number }}</div>
            <div v-if="namemanager(group.calls[0].manager_id)">
              Менеджер: {{ namemanager(group.calls[0].manager_id) }}
            </div>
          </div>
        </div>
      </li>
    </ul>
    <p v-else class="no-orders">Нет пропущенных звонков</p>
  </div>
</template>

<script>
import { ORDERS_API_BASE } from '@/config/api';
import axios from 'axios';  
import { mapState, mapActions, mapGetters } from 'vuex';
import { extractManagerCode, findManagerLabel } from '../utils/managerLookup';
export default {
  name: "MissedCalls",
  props: {
    calls: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sources: [], // Хранилище для данных из источника json
      isExpanded: false,
      copiedId:null,
      expandedGroups: new Set(), // Хранит раскрытые группы
      managersList: [],
    };
  },
  computed: {
    ...mapState({
      savedForms: state => state.savedFormsModule.savedForms // Доступ к savedForms из Vuex модуля
    }),
  ...mapGetters("sourceModule", {
    getTrunkByPhone: "getTrunkByPhone", // Подключение геттера как вычисляемого свойства
  }),
    // Группируем звонки по номеру телефона
    groupedCalls() {
      const groups = {};
      this.calls.forEach(call => {
        const phone = call.phone || '';
        if (!groups[phone]) {
          groups[phone] = {
            phone: phone,
            trunk: call.trunk,
            calls: []
          };
        }
        groups[phone].calls.push(call);
      });
      // Сортируем звонки внутри группы по времени (новые сверху)
      Object.values(groups).forEach(group => {
        group.calls.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      });
      // Сортируем группы по времени последнего звонка (новые сверху)
      const sortedGroups = Object.values(groups);
      sortedGroups.sort((a, b) => {
        // Берем первый звонок (самый новый) из каждой группы
        const lastCallA = a.calls[0];
        const lastCallB = b.calls[0];
        return new Date(lastCallB.timestamp) - new Date(lastCallA.timestamp);
      });
      return sortedGroups;
    },
    // Подсчет уникальных контактов (по номеру телефона)
    uniqueCallsCount() {
      return this.groupedCalls.length;
    },
    // Видимые группы (с учетом раскрытия)
    visibleGroupedCalls() {
      const groups = this.groupedCalls;
      return this.isExpanded ? groups : groups.slice(0, 5);
    },
    shouldShowExpandArrow() {
      return this.calls.length > 5;
    },
    namemanager() {
      return (managerValue) => findManagerLabel(this.managersList, managerValue);
    },
  },
  mounted() {
    this.user = this.$store.state.user;
    this.loadSources(); // Загружаем данные из source.json
    this.loadManagersList();
  },
  methods: {
    async loadManagersList() {
      try {
        const response = await fetch(ORDERS_API_BASE + '/managers.php');
        const data = await response.json();
        this.managersList = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error('Ошибка при получении справочника managers:', error);
      }
    },
      copyOrderNumber(phone) {
      // Копируем order.number и устанавливаем id для показа тултипа
      navigator.clipboard.writeText(phone.toString())
        .then(() => {
          this.copiedId = phone;
          // Скрываем тултип через 2 секунды
          setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        })
        .catch(err => {
          console.error("Ошибка копирования номера:", err);
        });
    },
    // Копирование всех пропущенных звонков
    copyAllCalls() {
      const allPhones = this.groupedCalls.map(group => group.phone).join('\n');
      navigator.clipboard.writeText(allPhones)
        .then(() => {
          this.copiedId = 'all';
          setTimeout(() => {
            this.copiedId = null;
          }, 2000);
        })
        .catch(err => {
          console.error("Ошибка копирования всех номеров:", err);
        });
    },
    // Переключение раскрытия группы
    toggleGroup(phone) {
      if (this.expandedGroups.has(phone)) {
        this.expandedGroups.delete(phone);
      } else {
        this.expandedGroups.add(phone);
      }
      // Принудительно обновляем реактивность
      this.$forceUpdate();
    },
      async loadSources() {
      try {
        const response = await fetch("/source.json"); // Загрузка JSON
        this.sources = await response.json();
        console.log("Источники загружены:", this.sources);
      } catch (error) {
        console.error("Ошибка загрузки sources.json:", error);
      }
    },
    getSourceById(trunk) {
      console.log(trunk);
      // Ищем источник по ID (trunk)
      return this.sources.find((source) => source.ID === trunk) || {
        label: "Неизвестный источник",
        value: "unknown",
      };
    },
    async makeCall(callphone, trunk) {


      console.log(trunk);

      if (!callphone || !this.$store.state.user.phone_extension) {
        console.error("Не указан номер телефона или внутренний номер пользователя.");
        return;
      }

      const internalNumber = this.$store.state.user.phone_extension;

      // Удаляем все символы, кроме цифр
      let phoneNumber = callphone.replace(/\D/g, '');

      // Преобразование номера, если он начинается с 8029 или других кодов
      if (phoneNumber.startsWith('80')) {
        phoneNumber = '375' + phoneNumber.slice(2);
      }
      else {
        phoneNumber = '375' + phoneNumber;
      }



      if (!phoneNumber) {
        console.error("Некорректный номер телефона:", callphone);
        return;
      }

      // clientId (secret) — только для инициации звонков через makecallexternal
      const clientId = "e16bc4fc51d243ae80ab476c51b1e7c2";
      const url = `https://bot.vochi.by/api/makecallexternal?code=${encodeURIComponent(internalNumber)}&phone=${encodeURIComponent('+' + phoneNumber)}&clientId=${clientId}`;

      try {
        const response = await axios.get(url);

        if (response.data && response.data.success === false) {
          console.error("Ошибка при инициации звонка:", response.data.message || response.data);
        } else {
          console.log("Звонок успешно инициирован:", (response.data && response.data.message) || response.data);
        }
      } catch (error) {
        console.error("Ошибка при обращении к API Vochi:", error);
      }


    // Проверяем, есть ли уже форма с таким номером телефона в savedForms
        const existingForm = this.savedForms.find(
            (form) => form.data && form.data.phone === phoneNumber
        );

        if (existingForm) {
                console.log(`Форма с номером телефона ${externalPhone} уже существует, сохранение отменено.`);
            } else {
                const defaultStatusGroups = ['new-group', 'delivery-group', 'approval-group'];

                this.fetchPhoneManagerData(phoneNumber, defaultStatusGroups).then((result) => {
                    const {
                        number,
                        numberOrder,
                        managerId = '',
                        orderMethod,
                        orderType,
                        site,
                        contragentType,
                        createdAt,
                    } = result.success ? result : {};

                    if (managerId !== '') {
                      const source = this.getSourceById(trunk);
                      console.log(source);
                      console.log('хуй');
                        this.saveBridgeCallAsFormOrder(
                            phoneNumber,
                            number,
                            numberOrder,
                            managerId,
                            orderMethod,
                            orderType,
                            site,
                            contragentType,
                            createdAt,
                            source
                        );
                        this.deleteCall(phoneNumber);
                    } else {
                     
                        console.log(`Форма с номером телефона ${phoneNumber} не найдена, создаём новую.`);
                        const source = this.getSourceById(trunk);
                        // Определяем, что это пропущенный новый звонок без заказа
                        const isMissedCall = true;
                        this.saveBridgeCallAsForm(phoneNumber, source, isMissedCall);
                        this.deleteCall(phoneNumber);
                    }
                });
            }







    },

    async fetchPhoneManagerData(phone, statusGroups) {
        try {
            const response = await axios.post(ORDERS_API_BASE + '/getPhoneManager.php', {
                phone,
                extendedStatus: statusGroups,
            });

            if (response.data.success && response.data.orderNumber && response.data.id) {
                const managerCode = response.data.customFieldsManager || extractManagerCode(response.data.manager);
                return {
                    success: true,
                    number: response.data.id,
                    numberOrder:response.data.orderNumber,
                    managerId: managerCode || '',
                    orderMethod: response.data.orderMethod,
                    orderType: response.data.orderType,
                    site: response.data.site,
                    contragentType: response.data.contragentType,
                    createdAt: response.data.createdAt,
                    customFieldsManager: managerCode || null,
                };
            }

            return { success: false };
        } catch (error) {
            console.error('Error fetching order data:', error.message);
            return { success: false };
        }
    },
    generateUniqueId() {
      return Math.floor(Date.now() / 1000);
    },

     ...mapActions({
      // Подключение экшенов из модуля savedFormsModule
      loadSavedForms: "savedFormsModule/loadSavedForms",
      saveForm: "savedFormsModule/saveForm",
      deleteForm: "savedFormsModule/deleteForm",

      // Подключение экшенов из модуля sourceModule
      addPhoneTrunk: "sourceModule/addPhoneTrunk", // Добавление phone -> trunk
    }),

    saveBridgeCallAsFormOrder(phone, number, numberOrder, managerId, orderMethod, orderType, site, contragentType, createdAt, source) {
  const formId = this.generateUniqueId();

  // Проверяем, есть ли уже форма с таким номером телефона в savedForms
  const existingForm = this.savedForms.find(
    (form) => form && form.phone === phone
  );

  if (existingForm) {
    alert(`Форма с номером телефона ${phone} уже существует!`);
    console.log(`Форма с номером телефона ${phone} уже существует в savedForms.`);
    return; // Не добавляем форму, если она уже есть
  }


                            const formData = { id:number, idorder:number, number:numberOrder, site: { value: site}, created:createdAt, phone:phone, orderMethod:{label: source.label,value: source.value}};
                            this.loading = false;
                            
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
                            this.saveForm(formData);
                        
},

async saveBridgeCallAsForm(phone, source, isMissedCall = false) {
  const formId = this.generateUniqueId();

  // Проверяем, есть ли уже форма с таким номером телефона в savedForms
  const existingForm = this.savedForms.find(
    (form) => form && form.phone === phone
  );

  if (existingForm) {
    alert(`Форма с номером телефона ${phone} уже существует!`);
    console.log(`Форма с номером телефона ${phone} уже существует в savedForms.`);
    return; // Не добавляем форму, если она уже есть
  }








  // Формируем объект данных формы
  const formOrder = {
    order: {
      id: formId,
      orderType: {label: "Физическое лицо", value: "eshop-individual"},
      site: {label: "Центральный офис 1akb.by", value: "1akb-by"},
      managerId: {
        label: this.user.label, // Передаём label
        value: this.user.id, // Передаём value
      },
      orderMethod: {
        label: source.label, // Передаём label
        value: source.value, // Передаём value
      },
      contragent:{
        contragentType:{ label: 'Физическое лицо', value: 'individual' },
      },
      
      data: {
        phone, // Сохраняем только номер телефона
        
      },
      products: [], // Пустой массив продуктов
      comments: {
        customerComment: '',
        managerComment: isMissedCall ? 'Пропущенный звонок без заказа' : '',
      },
      shipment: {
        shipmentDate: null,
        deliveryCost: null,
        deliveryAddress: '',
        deliveryDate: null,
        weight: null,
        dimensions: {
          length: null,
          width: null,
          height: null,
        },
      },
      deliveryTime: {
        from: null,
        to: null,
      },
      customTime: null,
      oneTimeDiscountAmount: null,
      oneTimeDiscountPercent: null,
      customFields: {
        manager: {
          label: this.user.label,
          value: this.user.symbolicCode
        }
      }
    }
  };

  // Сохраняем форму через Vuex
  //this.saveForm(formData);
  try {
                    const response = await axios.post(ORDERS_API_BASE + '/saveCallOrder.php', formOrder);
                        if (response.data.success) {
                            const { orderId, orderSite, orderCreated } = response.data;
                            //this.$router.push({ name: 'OrderEdit', params: { orderId, site: orderSite } });
                            const formData = { id:orderId, idorder:orderId, site: orderSite ? orderSite : {label: "Центральный офис 1akb.by", value: "1akb-by"}, created:orderCreated, phone:phone, orderMethod:{label: source.label,value: source.value}};
                            this.loading = false;
                            alert('Заказ успешно созданнн!');
                            this.$store.dispatch('savedFormsModule/clearSavedForms');
                            this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
                            this.saveForm(formData);
                        } else {
                            this.loading = false;
                            alert('Ошибка при создании заказа: ' + response.data.message);
                        }
                    } catch (error) {
                        console.error('Ошибка при создании заказа:', error);
                        alert('Произошла ошибка при создании заказаffff.');
                        this.loading = false;
                    }
  /*console.log(
    `Форма с номером телефона ${phone} успешно сохранена. Источник: ${source.label} (${source.value})`
  );*/
},

    deleteCall(phone) {
      // Удаляем звонок локально
      this.$emit("delete-call", phone);
    },

    deleteEmptyCalls() {
      // Удаляем все пустые звонки
      this.calls.forEach(call => {
        if (!call.phone || call.phone.trim() === '') {
          this.deleteCall(call.phone);
        }
      });
    },

    formatDate(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
      console.log("isExpanded:", this.isExpanded); // Для отладки
    },
  },
};
</script>



<style scoped>
.data_phone {
  font-size:10px;

}

.call_info {
  background: #eefdff;
    padding: 4px;
    border-radius: 4px;
    font-size: 10px;
    margin-top: 5px;
}

.number_phone {
  font-weight:600;
  font-size:16px;
  position:relative;
  padding-left:20px;
}

.number_phone:before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2322c55e'%3E%3Cpath d='M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1-.24c1.12.37 2.33.57 3.59.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.07 21 3 13.93 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.26.2 2.47.57 3.59a1 1 0 0 1-.24 1l-2.21 2.2z'/%3E%3C/svg%3E");
  content: "";
  width: 18px;
  height: 18px;
  display: block;
  background-size: contain;
  position: absolute;
  left: 0;
  top: 3px;
  background-repeat: no-repeat;
}

.missed-calls ul {
  list-style-type: none;
  padding-left: 0;
  margin-bottom:0px;
}

.missed-calls li {
  padding: 4px;
    border-bottom: solid 1px #dee2e6;
    margin: 6px;
    cursor:pointer;
    position: relative;
}

.missed-calls ul li:last-child { 
border-bottom:0px;
}


.h2 {
background: linear-gradient(180deg, #dc3545, #b10b1b) !important;
    color: #fff;
    padding: 7px 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    text-align: center;
    margin-bottom: 1px;
    border-radius: 0px;
    font-size: 14px;
    width:100%;
}

.missed-calls {
  margin-top:20px;
  padding: 0px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgb(0 0 0 / 5%);
    overflow: hidden;
}

.no-orders {
  text-align:center;
  margin-top:15px;
  line-height: 14px;
}

.missed-calls .header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer; /* Указатель на весь заголовок */
}
.missed-calls .toggle-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url('/path/to/arrow-down.svg'); /* Стрелка вниз */
  transition: transform 0.3s ease;
}
.missed-calls .toggle-icon.expanded {
  transform: rotate(180deg);
  background-image: url('/path/to/arrow-up.svg'); /* Стрелка вверх */
}


.missed-calls li:hover {
  background: #e3f1e3;
  border-bottom: solid 1px #e3f1e3;
}

.delite_phone {
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 21.97 22'%3e%3cpath fill-rule='evenodd' d='M.19 21.8a.718.718 0 0 0 .44.2.745.745 0 0 0 .45-.2l9.91-9.9 9.9 9.9a.606.606 0 0 0 .9 0 .631.631 0 0 0 0-.9L11.88 11l9.91-9.9a.631.631 0 0 0 0-.9.563.563 0 0 0-.9 0l-9.9 9.9L1.08.2a.553.553 0 0 0-.89 0 .631.631 0 0 0 0 .9l9.9 9.9-9.9 9.9a.631.631 0 0 0 0 .9z'%3e%3c/path%3e%3c/svg%3e");
    width: 10px;
    height: 10px;
    background-position: center;
    background-size: contain;
    background-color: transparent;
    border: none;
    background-repeat: no-repeat;
    position: absolute;
    top: 2px;
    right: 2px;
    z-index: 2000;
}


.copy-btn svg,
.fa-copy svg {
  width: 17px;
  height: 17px;
  opacity: 0.5;
  display: block;
}

.copy-btn {
  background: none;
  border: none;
  cursor: pointer;
  margin-left: 5px;
  padding: 0;
  position: absolute;
  right: -2px;
  top: 18px;
  z-index: 99999999;
}

.tooltips {
  position: absolute;
  top: -40px; /* Расстояние от кнопки, можно настроить */
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.tooltips-arrow {
  position: absolute;
  bottom: -5px; /* Расположение стрелочки под тултипом */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
}

.copy-all-container {
  padding: 0px;
  text-align: center;
  border-bottom: 1px solid #dee2e6;
  position: relative;
  background: #e3f1e3;
}

.copy-all-btn {
  background: transparent;
  color: #000000;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  cursor: pointer;
  font-size: 12px;
  transition: opacity 0.2s;
  position: relative;
}

.copy-all-btn .tooltips {
  position: absolute;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
  background: #333;
  color: #fff;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 10;
}

.call-group {
  padding: 4px;
  border-bottom: solid 1px #dee2e6;
  margin: 6px;
  position: relative;
}

.call-group-header {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.call-group-header:hover {
  background: #e3f1e3;
}

.phone-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.call-count {
  font-size: 12px;
  color: #636f7f;
  font-weight: normal;
  margin-top: 4px;
}

.expand-icon {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  transition: transform 0.3s;
  color: #636f7f;
}

.expand-icon.expanded {
  transform: translateY(-50%) rotate(180deg);
}

.call-times-list {
  list-style: none;
  padding: 8px 0 0 20px;
  margin: 0;
  border-top: 1px solid #e9ecee;
  margin-top: 8px;
}

.call-time-item {
  padding: 6px 0;
  border-bottom: 1px dashed #e9ecee;
}

.call-time-item:last-child {
  border-bottom: none;
}

.single-call-info {
  padding-top: 4px;
}

</style>
